export const ChevronUpIcon = () => {
  return <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="ChevronUpIcon" data-sentry-source-file="chevron-up.tsx">
      <path d="M16 10.9385L2.13334 25.3385L0 23.2052L16 6.67188L32 23.2052L30.9333 24.2719C30.4 24.8052 29.8667 25.3385 29.8667 25.3385L16 10.9385Z" data-sentry-element="path" data-sentry-source-file="chevron-up.tsx" />
    </svg>;
};